import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { getCompetitors } from 'features/newsales/newsalesActions';
import LeadSourceImage from 'pages/settings/salesNewSettings/components/LeadSourceImage';

import { useLeadForm } from '../LeadFormContext';
import {
  CheckIcon,
  CheckboxWrapper,
  CompetitorCard,
  CompetitorGrid,
  CompetitorName,
  CompetitorType,
  Container,
  FlexContainer,
  LoadingSpinner,
  LogoWrapper,
  MainInfoContent,
  SubTitle,
  Title,
} from './CompetitorInfo.styles';

const CompetitorInfo = () => {
  const dispatch = useDispatch();
  const { formData, updateFormData } = useLeadForm();
  const [selected, setSelected] = useState(formData.competitorId || '');
  const [competitors, setCompetitors] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCompetitors = async () => {
      setLoading(true);
      try {
        const result = await dispatch(
          getCompetitors({
            status: 'enabled',
            limit: 100,
          })
        );
        if (result.payload?.data) {
          setCompetitors(result.payload.data);
        }
      } catch (error) {
        console.error('Error fetching competitors:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCompetitors();
  }, [dispatch]);

  const truncateText = (text = '', maxLength = 12) => {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };

  const handleCompetitorClick = (competitorId) => {
    setSelected((prevSelected) => (prevSelected === competitorId ? '' : competitorId));
  };

  useEffect(() => {
    updateFormData({ competitorId: selected || null });
  }, [selected]);

  return (
    <Container>
      <Title>Select Competitors</Title>
      <SubTitle>Select competitors</SubTitle>
      <MainInfoContent>
        {loading ? (
          <LoadingSpinner>Loading competitors...</LoadingSpinner>
        ) : (
          <CompetitorGrid>
            {competitors.map((comp) => (
              <CompetitorCard
                key={comp.id}
                isActive={selected === comp.id}
                onClick={() => handleCompetitorClick(comp.id)}
              >
                <LogoWrapper>
                  <LeadSourceImage imagePath={comp.image} alt={comp.name} size={48} />
                </LogoWrapper>

                <FlexContainer>
                  <CompetitorName title={comp.name}>{truncateText(comp.name)}</CompetitorName>
                  <CompetitorType title={comp.description || 'Competitor'}>
                    {truncateText(comp.description || 'Competitor')}
                  </CompetitorType>
                </FlexContainer>

                <CheckboxWrapper isActive={selected === comp.id}>
                  {selected === comp.id && (
                    <CheckIcon viewBox="0 0 24 24">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                    </CheckIcon>
                  )}
                </CheckboxWrapper>
              </CompetitorCard>
            ))}
          </CompetitorGrid>
        )}
      </MainInfoContent>
    </Container>
  );
};

export default CompetitorInfo;
